import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Register = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [isComplete, setIsComplete] = useState(false);
    const [countdown, setCountdown] = useState(5);

    const formUrl = import.meta.env.VITE_REGISTRATION_FORM_URL;
    const navigate = useNavigate();

    useEffect(() => {
        document.body.style.overflow = 'hidden'
        return () => {
            document.body.style.overflow = ''
        }
    }, [])

    useEffect(() => {
        const handleSuccess = () => {
            setIsComplete(true);
        };

        window.addEventListener('surveySubmissionSuccess', handleSuccess);
        return () => window.removeEventListener('surveySubmissionSuccess', handleSuccess);
    }, []);

    useEffect(() => {
        if (!isComplete) {
            return;
        }

        const interval = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    navigate('/signin');
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [isComplete, navigate]);

    return (
        <div className="register">
            {isLoading && (
                <div className="page--loading">
                    <div className="loading" role="status" aria-live="polite">
                        <div className="loading__spinner" />
                        <div className="loading__message">
                            Loading registration form
                        </div>
                    </div>
                </div>
            )}

            {isComplete ? (
                <div className="register__success">
                    <h2>You're all set!</h2>
                    <p>
                        Thank you for registering - your account has been created successfully.
                    </p>
                    <p>
                        Taking you to the sign-in page in <strong>{countdown}</strong>...
                    </p>
                </div>
            ) : (
                <div className="register__iframe-container">
                    <iframe
                        className="register__iframe"
                        src={formUrl}
                        title="Register for MyAccount"
                        loading="eager"
                        onLoad={() => setIsLoading(false)}
                        allow="clipboard-write"
                    />
                </div>
            )}
        </div>
    )
}

export default Register
